// extracted by mini-css-extract-plugin
export default {"carousel":"PageZuzuGo_carousel__lFLck","mobile":"PageZuzuGo_mobile__Dr2ec","noItems":"PageZuzuGo_noItems__OCGL0","disabled":"PageZuzuGo_disabled__wkOV8"};